export const uk = {
    'request-error': 'Произошла ошибка. Попробуйте еще раз.'
};
